const CptPositionStacking = {
    CAP_POSITION_STACKING_SET_DATA_FROM_STORAGE: 'CAP_POSITION_STACKING_SET_DATA_FROM_STORAGE',
    CAP_POSITION_STACKING_SET_IS_USED: 'CAP_POSITION_STACKING_SET_IS_USED',
    CAP_POSITION_STACKING_ADD_ITEM: 'CAP_POSITION_STACKING_ADD_ITEM',
    CAP_POSITION_STACKING_REMOVE_ITEM: 'CAP_POSITION_STACKING_REMOVE_ITEM',
};

export default CptPositionStacking;
